import { forEachPageBlock } from 'src/helpers/pageDocumentUtils';
import { MarkFileUsageFn } from 'src/helpers/pageContentFileUsage';
import { IImageBlock } from 'src/interfaces/PageBlock';
import { SocialShareSettings } from 'src/interfaces/SocialShare';

const CONTENT_TYPE = 'socialShare';
const CONTENT_ID = 'site-default';

interface SocialShareFileUsageRef {
  fileId: string;
  fieldName: string;
}

function pushFileRef(refs: SocialShareFileUsageRef[], fileId: string | undefined, fieldName: string) {
  const id = fileId?.trim();
  if (!id) return;
  refs.push({ fileId: id, fieldName });
}

function collectSocialShareFileUsageRefs(
  settings: SocialShareSettings | null | undefined,
): SocialShareFileUsageRef[] {
  if (!settings) return [];

  const refs: SocialShareFileUsageRef[] = [];
  pushFileRef(refs, settings.imageFileId, 'shareImage');
  pushFileRef(refs, settings.backgroundImageFileId, 'composer-background');

  forEachPageBlock(settings.composedDocument, block => {
    if (block.type === 'image') {
      const imageBlock = block as IImageBlock;
      for (const image of imageBlock.images ?? []) {
        pushFileRef(refs, image.imageFileId, `block-${block.id}`);
      }
    }
  });

  return refs;
}

export async function syncSocialShareFileUsage(
  markFileUsage: MarkFileUsageFn,
  previousSettings: SocialShareSettings | null | undefined,
  nextSettings: SocialShareSettings,
): Promise<void> {
  const previousRefs = collectSocialShareFileUsageRefs(previousSettings);
  const nextRefs = collectSocialShareFileUsageRefs(nextSettings);
  const nextKeys = new Set(nextRefs.map(ref => `${ref.fileId}:${ref.fieldName}`));

  for (const ref of nextRefs) {
    await markFileUsage(ref.fileId, true, CONTENT_TYPE, CONTENT_ID, ref.fieldName, {
      silent: true,
    });
  }

  for (const ref of previousRefs) {
    const key = `${ref.fileId}:${ref.fieldName}`;
    if (!nextKeys.has(key)) {
      await markFileUsage(ref.fileId, false, CONTENT_TYPE, CONTENT_ID, ref.fieldName, {
        silent: true,
      });
    }
  }
}
